import React, { useEffect, useState } from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Get, Put } from '@app/utils/httpProvider';
import { CHUONGTRINHHOC_API, CHUYENNGANH_API } from '@app/utils/apiUrl';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { messageError, messageToast, status200 } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import Editor from '@app/components/editor/Editor';
import {AsyncPaginate} from 'react-select-async-paginate';

const schema = yup.object().shape({
    tenChuongTrinhHoc: yup.string().required(messageError.emptyMessage)
});

const ChuongTrinhHocEdit = () => {
    const history = useHistory();
    const queryClient = useQueryClient();
    const location = useLocation();
    const params = new URLSearchParams(location.search.substring(1));
    const itemId = params.get('id');

    const itemQuery = useQuery(['chuongTrinhHoc', itemId], () => Get(CHUONGTRINHHOC_API.GET_ITEM, itemId), {
        enabled: !!itemId
    });

    const editMutation = useMutation((value) => Put(CHUONGTRINHHOC_API.UPDATE_ITEM, itemId, value));

    const handleEdit = (values) => {
        const model = {
            ...values,
        };

        model.chuyenNganhId =
            values.chuyenNganhId === '' ||
                values.chuyenNganhId === 'null' ||
                values.chuyenNganhId === undefined
                ? ''
                : values.chuyenNganhId.value;

        editMutation.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastUpdateError);
                } else {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    queryClient.setQueryData(['chuongTrinhHoc', itemId], model);
                    history.push(URI_INTERNAL.CHUONGTRINHHOC_PATH);
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại !');
            }
        });
    };

    const loadOptionsChuyenNganh = async (search, loadedOptions, { page }) => {
        const pageSize = 10;
        const res = await Get(CHUYENNGANH_API.GET_PAGING, null, {
            PageIndex: page,
            PageSize: pageSize,
            Keyword: search // pass the input text to filter server-side
        });

        const data = res.data || [];
        const options = data.map((x) => ({
            label: `${x.maChuyenNganh} - ${x.tenChuyenNganh}`,
            value: x.id
        }));

        // assume your API returns total count or a flag for more pages
        const hasMore = data.length === pageSize;
        return {
            options,
            hasMore,
            additional: { page: page + 1 }
        };
    };

    if (itemQuery.isLoading) {
        return <div>Đang tải....</div>;
    }

    if (itemQuery.isError || !itemQuery.data) {
        return <div>Có lỗi xảy ra hoặc không tìm thấy chương trình học</div>;
    }

    const currentData = itemQuery.data;

    return (
        <Card>
            <Card.Header as="h5">Sửa chương trình học</Card.Header>
            <Card.Body>
                <Formik
                    enableReinitialize
                    validationSchema={schema}
                    onSubmit={(values) => handleEdit(values)}
                    initialValues={{
                        tenChuongTrinhHoc: currentData.tenChuongTrinhHoc || currentData.TenChuongTrinhHoc || '',
                        chuyenNganhId: currentData
                            .chuyenNganhId != NIL_UUID
                            ? {
                                label: currentData.chuyenNganh?.maChuyenNganh + " - " + currentData.chuyenNganh?.tenChuyenNganh,
                                value: currentData.chuyenNganhId
                            }
                            : {},
                        moTa: currentData.moTa || currentData.MoTa || ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label column sm={2}>Tên chương trình học</Form.Label>
                                <Col sm={10}>
                                    <Form.Control
                                        name="tenChuongTrinhHoc"
                                        value={values.tenChuongTrinhHoc}
                                        onChange={handleChange}
                                        isInvalid={!!errors.tenChuongTrinhHoc}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tenChuongTrinhHoc}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label column sm={2}>Chuyên ngành</Form.Label>
                                <Col sm={10}>
                                    <AsyncPaginate
                                        name="chuyenNganhId"
                                        id="chuyenNganhId"
                                        placeholder="Chọn chuyên ngành"
                                        value={values.chuyenNganhId}
                                        loadOptions={loadOptionsChuyenNganh}
                                        styles={styleSelectDefault}
                                        isClearable
                                        onChange={(selectedOption) => {
                                            // const event = {
                                            //     target: {
                                            //         name: 'accountPatients',
                                            //         value: selectedOption
                                            //     }
                                            // };
                                            // setAccountHisId(event);
                                            setFieldValue(
                                                'chuyenNganhId',
                                                selectedOption,
                                                true
                                            );
                                        }}
                                        additional={{
                                            page: 1
                                        }}
                                    />
                                    <div
                                        style={{
                                            display: 'block',
                                            color: '#dc3545'
                                        }}
                                        className="invalid-feedback"
                                    >
                                        {errors.chuyenNganhId}
                                    </div>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Mô tả
                                </Form.Label>
                                <Col sm="10">
                                    <Col sm="10">
                                        <Editor
                                            name="moTa"
                                            value={values.moTa}
                                            onChange={(value) => {
                                                setFieldValue(
                                                    'moTa',
                                                    value
                                                );
                                            }}
                                        />
                                    </Col>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button type="submit" theme="primary">
                                            Cập nhật
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button onClick={() => history.push(URI_INTERNAL.CHUONGTRINHHOC_PATH)} theme="secondary">
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default ChuongTrinhHocEdit;
